import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })

  let type = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
    path: 'patient_option',
  })

  return function onClick() {
    submit({ type: 'schedule', check_existing: type === 'new' })
  }
}

/**
 *
 * @param {Object} scheduling
 * @param {Object} appointment_overlay
 * @returns
 */
export function isDisabled(scheduling, appointment_overlay) {
  return (
    !appointment_overlay.template_exists_in_location ||
    (!scheduling?.slot_id && !scheduling.untemplated_slot.id)
  )
}
